var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { TswagClient } from "./../commons/TswagClient";
import { Error as ApiError } from "./../models/V1/Primitives/Error/Error";
import { Period } from "./../models/V1/Cesop/Periods/Period";
import { CreateFileResult } from "./../models/V1/Cesop/Periods/CreateFileResult";
import { SourceFile } from "./../models/V1/Cesop/Periods/SourceFile";
import { PossibleStatusChange } from "./../models/V1/Cesop/Periods/StatusChanges/PossibleStatusChange";
import { ValidationErrorCollection } from "./../models/V1/Cesop/Periods/Validation/Source/ValidationErrorCollection";
import { PeriodSearchResponse } from "./../models/V1/Cesop/Periods/Search/PeriodSearchResponse";
export class CesopPeriods {
  /**
   * Creates an instance of CesopPeriods.
   * @param {string} [baseUrl]
   * @param {{ fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }} [http]
   * @memberof CesopPeriods
   */
  constructor(baseUrl, http) {
    __publicField(this, "http");
    __publicField(this, "baseUrl");
    this.baseUrl = baseUrl;
    this.http = http ? http : window;
  }
  /**
   * @param AddMessageResponseRq_ _addMessageResponseRq
   * @returns Promise<AddMessageResponseRq_>
   * @memberof CesopPeriods
   */
  addMessageResponse(pAddMessageResponseRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/Messages/{messageId}/Responses", "POST", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "periodId", value: pAddMessageResponseRq.periodId, required: true },
      { name: "messageId", value: pAddMessageResponseRq.messageId, required: true }
    ]);
    client.addBody({ value: pAddMessageResponseRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 201 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ApproveSummaryRq_ _approveSummaryRq
   * @returns Promise<ApproveSummaryRq_>
   * @memberof CesopPeriods
   */
  approveSummary(pApproveSummaryRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/approve", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pApproveSummaryRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeMessageStatusRq_ _changeMessageStatusRq
   * @returns Promise<ChangeMessageStatusRq_>
   * @memberof CesopPeriods
   */
  changeMessageStatus(pChangeMessageStatusRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/Messages/{messageId}/status", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "periodId", value: pChangeMessageStatusRq.periodId, required: true },
      { name: "messageId", value: pChangeMessageStatusRq.messageId, required: true }
    ]);
    client.addBody({ value: pChangeMessageStatusRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeStatusRq_ _changeStatusRq
   * @returns Promise<ChangeStatusRq_>
   * @memberof CesopPeriods
   */
  changeStatus(pChangeStatusRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/ChangeStatus", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pChangeStatusRq.id, required: true }]);
    client.addBody({ value: pChangeStatusRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetRq_ _getRq
   * @returns Promise<GetRq_>
   * @memberof CesopPeriods
   */
  get(pGetRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}", "GET", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pGetRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: Period },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ChangeUploadTypeRq_ _changeUploadTypeRq
   * @returns Promise<ChangeUploadTypeRq_>
   * @memberof CesopPeriods
   */
  changeUploadType(pChangeUploadTypeRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pChangeUploadTypeRq.id, required: true }]);
    client.addBody({ value: pChangeUploadTypeRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DeleteRq_ _deleteRq
   * @returns Promise<DeleteRq_>
   * @memberof CesopPeriods
   */
  delete(pDeleteRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}", "DELETE", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pDeleteRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param PayeeSourceFileUploadedRq_ _payeeSourceFileUploadedRq
   * @returns Promise<PayeeSourceFileUploadedRq_>
   * @memberof CesopPeriods
   */
  payeeSourceFileUploaded(pPayeeSourceFileUploadedRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/payees", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pPayeeSourceFileUploadedRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CreatePayeesSourceFileRq_ _createPayeesSourceFileRq
   * @returns Promise<CreatePayeesSourceFileRq_>
   * @memberof CesopPeriods
   */
  createPayeesSourceFile(pCreatePayeesSourceFileRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/payees", "POST", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pCreatePayeesSourceFileRq.id, required: true }]);
    client.addBody({ value: pCreatePayeesSourceFileRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 201, clazz: CreateFileResult },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DeletePayeeSourceFileRq_ _deletePayeeSourceFileRq
   * @returns Promise<DeletePayeeSourceFileRq_>
   * @memberof CesopPeriods
   */
  deletePayeeSourceFile(pDeletePayeeSourceFileRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/payees", "DELETE", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pDeletePayeeSourceFileRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CreateSourceFileRq_ _createSourceFileRq
   * @returns Promise<CreateSourceFileRq_>
   * @memberof CesopPeriods
   */
  createSourceFile(pCreateSourceFileRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/sourcefiles", "POST", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pCreateSourceFileRq.id, required: true }]);
    client.addBody({ value: pCreateSourceFileRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 201, clazz: CreateFileResult },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param CreateTemporalXmlFileRq_ _createTemporalXmlFileRq
   * @returns Promise<CreateTemporalXmlFileRq_>
   * @memberof CesopPeriods
   */
  createTemporalXmlFile(pCreateTemporalXmlFileRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/temporalxml", "POST", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "periodId", value: pCreateTemporalXmlFileRq.periodId, required: true }]);
    client.addBody({ value: pCreateTemporalXmlFileRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 201, clazz: CreateFileResult },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetSourceFileRq_ _getSourceFileRq
   * @returns Promise<GetSourceFileRq_>
   * @memberof CesopPeriods
   */
  getSourceFile(pGetSourceFileRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/SourceFiles/{id}", "GET", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "periodId", value: pGetSourceFileRq.periodId, required: true },
      { name: "id", value: pGetSourceFileRq.id, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: SourceFile },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param FileUploadedRq_ _fileUploadedRq
   * @returns Promise<FileUploadedRq_>
   * @memberof CesopPeriods
   */
  fileUploaded(pFileUploadedRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/SourceFiles/{id}", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "periodId", value: pFileUploadedRq.periodId, required: true },
      { name: "id", value: pFileUploadedRq.id, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DeleteFileRq_ _deleteFileRq
   * @returns Promise<DeleteFileRq_>
   * @memberof CesopPeriods
   */
  deleteFile(pDeleteFileRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/SourceFiles/{id}", "DELETE", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "periodId", value: pDeleteFileRq.periodId, required: true },
      { name: "id", value: pDeleteFileRq.id, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DeleteProofFileRq_ _deleteProofFileRq
   * @returns Promise<DeleteProofFileRq_>
   * @memberof CesopPeriods
   */
  deleteProofFile(pDeleteProofFileRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/Messages/{messageId}/Proofs/{proofId}",
      "DELETE",
      "application/json; charset=UTF-8",
      "application/json",
      options
    );
    client.addPathParams([
      { name: "periodId", value: pDeleteProofFileRq.periodId, required: true },
      { name: "messageId", value: pDeleteProofFileRq.messageId, required: true },
      { name: "proofId", value: pDeleteProofFileRq.proofId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 201 }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DeleteSubmissionProofRq_ _deleteSubmissionProofRq
   * @returns Promise<DeleteSubmissionProofRq_>
   * @memberof CesopPeriods
   */
  deleteSubmissionProof(pDeleteSubmissionProofRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/SubmissionProofFiles/{fileReference}", "DELETE", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "id", value: pDeleteSubmissionProofRq.id, required: true },
      { name: "fileReference", value: pDeleteSubmissionProofRq.fileReference, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DeleteTemporalXmlFileRq_ _deleteTemporalXmlFileRq
   * @returns Promise<DeleteTemporalXmlFileRq_>
   * @memberof CesopPeriods
   */
  deleteTemporalXmlFile(pDeleteTemporalXmlFileRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/temporalxml/{fileId}", "DELETE", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "periodId", value: pDeleteTemporalXmlFileRq.periodId, required: true },
      { name: "fileId", value: pDeleteTemporalXmlFileRq.fileId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadFileRq_ _downloadFileRq
   * @returns Promise<DownloadFileRq_>
   * @memberof CesopPeriods
   */
  downloadFile(pDownloadFileRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/Cesop/Periods/{id}/files/{fileReference}",
      "GET",
      "application/json; charset=UTF-8",
      "text/xml, text/csv, application/pdf, application/zip, application/xls, application/xlsx",
      options
    );
    client.addPathParams([
      { name: "id", value: pDownloadFileRq.id, required: true },
      { name: "fileReference", value: pDownloadFileRq.fileReference, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 404, clazz: ApiError },
        { statusCode: 409, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param DownloadProofFilesRq_ _downloadProofFilesRq
   * @returns Promise<DownloadProofFilesRq_>
   * @memberof CesopPeriods
   */
  downloadProofFiles(pDownloadProofFilesRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/SubmissionProofFiles", "GET", "application/json; charset=UTF-8", "application/zip", options);
    client.addPathParams([{ name: "id", value: pDownloadProofFilesRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, isFile: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param FinalizeUploadRq_ _finalizeUploadRq
   * @returns Promise<FinalizeUploadRq_>
   * @memberof CesopPeriods
   */
  finalizeUpload(pFinalizeUploadRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/finalize", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pFinalizeUploadRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetAvailableStatusChangesRq_ _getAvailableStatusChangesRq
   * @returns Promise<GetAvailableStatusChangesRq_>
   * @memberof CesopPeriods
   */
  getAvailableStatusChanges(pGetAvailableStatusChangesRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/AvailableChanges", "GET", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "periodId", value: pGetAvailableStatusChangesRq.periodId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: PossibleStatusChange, isArray: true },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetPayeeValidationErrorsRq_ _getPayeeValidationErrorsRq
   * @returns Promise<GetPayeeValidationErrorsRq_>
   * @memberof CesopPeriods
   */
  getPayeeValidationErrors(pGetPayeeValidationErrorsRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/payees/ValidationErrors", "GET", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pGetPayeeValidationErrorsRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: ValidationErrorCollection },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param GetTransactionValidationErrorsRq_ _getTransactionValidationErrorsRq
   * @returns Promise<GetTransactionValidationErrorsRq_>
   * @memberof CesopPeriods
   */
  getTransactionValidationErrors(pGetTransactionValidationErrorsRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/sourceFiles/{sourceFileId}/ValidationErrors",
      "GET",
      "application/json; charset=UTF-8",
      "application/json",
      options
    );
    client.addPathParams([
      { name: "periodId", value: pGetTransactionValidationErrorsRq.periodId, required: true },
      { name: "sourceFileId", value: pGetTransactionValidationErrorsRq.sourceFileId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: ValidationErrorCollection },
        { statusCode: 404, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param RegenerateXmlRq_ _regenerateXmlRq
   * @returns Promise<RegenerateXmlRq_>
   * @memberof CesopPeriods
   */
  regenerateXml(pRegenerateXmlRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/regenerate", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "periodId", value: pRegenerateXmlRq.periodId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param RejectSummaryRq_ _rejectSummaryRq
   * @returns Promise<RejectSummaryRq_>
   * @memberof CesopPeriods
   */
  rejectSummary(pRejectSummaryRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/reject", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "id", value: pRejectSummaryRq.id, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ReopenRq_ _reopenRq
   * @returns Promise<ReopenRq_>
   * @memberof CesopPeriods
   */
  reopen(pReopenRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/reopen", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "periodId", value: pReopenRq.periodId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param ResendRq_ _resendRq
   * @returns Promise<ResendRq_>
   * @memberof CesopPeriods
   */
  resend(pResendRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/Messages/{messageId}/resend", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "periodId", value: pResendRq.periodId, required: true },
      { name: "messageId", value: pResendRq.messageId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SearchRq_ _searchRq
   * @returns Promise<SearchRq_>
   * @memberof CesopPeriods
   */
  search(pSearchRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/search", "POST", "application/json; charset=UTF-8", "application/json", options);
    client.addBody({ value: pSearchRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [
        { statusCode: 200, clazz: PeriodSearchResponse },
        { statusCode: 400, clazz: ApiError }
      ]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SendRq_ _sendRq
   * @returns Promise<SendRq_>
   * @memberof CesopPeriods
   */
  send(pSendRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/Messages/{messageId}/send", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "periodId", value: pSendRq.periodId, required: true },
      { name: "messageId", value: pSendRq.messageId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param StartCorrectionRq_ _startCorrectionRq
   * @returns Promise<StartCorrectionRq_>
   * @memberof CesopPeriods
   */
  startCorrection(pStartCorrectionRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/Version/{versionId}/RequestCorrection",
      "PATCH",
      "application/json; charset=UTF-8",
      "application/json",
      options
    );
    client.addPathParams([
      { name: "periodId", value: pStartCorrectionRq.periodId, required: true },
      { name: "versionId", value: pStartCorrectionRq.versionId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param SwitchToManualCorrectionRq_ _switchToManualCorrectionRq
   * @returns Promise<SwitchToManualCorrectionRq_>
   * @memberof CesopPeriods
   */
  switchToManualCorrection(pSwitchToManualCorrectionRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/SwitchToManualCorrection", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([{ name: "periodId", value: pSwitchToManualCorrectionRq.periodId, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param TemporalXmlFileUploadedRq_ _temporalXmlFileUploadedRq
   * @returns Promise<TemporalXmlFileUploadedRq_>
   * @memberof CesopPeriods
   */
  temporalXmlFileUploaded(pTemporalXmlFileUploadedRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/temporalxml/{fileId}/uploaded", "PATCH", "application/json; charset=UTF-8", "application/json", options);
    client.addPathParams([
      { name: "periodId", value: pTemporalXmlFileUploadedRq.periodId, required: true },
      { name: "fileId", value: pTemporalXmlFileUploadedRq.fileId, required: true }
    ]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UpdateSubmissionDateRq_ _updateSubmissionDateRq
   * @returns Promise<UpdateSubmissionDateRq_>
   * @memberof CesopPeriods
   */
  updateSubmissionDate(pUpdateSubmissionDateRq, options = {}) {
    const client = new TswagClient(
      this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/Version/{versionId}/SubmissionDate",
      "PATCH",
      "application/json; charset=UTF-8",
      "text/plain, application/json, text/json",
      options
    );
    client.addPathParams([
      { name: "periodId", value: pUpdateSubmissionDateRq.periodId, required: true },
      { name: "versionId", value: pUpdateSubmissionDateRq.versionId, required: true }
    ]);
    client.addBody({ value: pUpdateSubmissionDateRq.body });
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadFileRq_ _uploadFileRq
   * @returns Promise<UploadFileRq_>
   * @memberof CesopPeriods
   */
  uploadFile(pUploadFileRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{periodId}/Messages/Files", "POST", "multipart/form-data", "application/json", options);
    client.addPathParams([{ name: "periodId", value: pUploadFileRq.periodId, required: true }]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadFileRq.file }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 200 }]
    };
    return client.fetch(this.http, respDescriptor);
  }
  /**
   * @param UploadSubmissionProofRq_ _uploadSubmissionProofRq
   * @returns Promise<UploadSubmissionProofRq_>
   * @memberof CesopPeriods
   */
  uploadSubmissionProof(pUploadSubmissionProofRq, options = {}) {
    const client = new TswagClient(this.baseUrl + "/api/v1/Cesop/Periods/{id}/Versions/{versionId}/SubmissionProofFiles", "POST", "multipart/form-data", "application/json", options);
    client.addPathParams([
      { name: "id", value: pUploadSubmissionProofRq.id, required: true },
      { name: "versionId", value: pUploadSubmissionProofRq.versionId, required: true }
    ]);
    client.addFormData("multipart/form-data", [{ name: "file", value: pUploadSubmissionProofRq.file, required: true }]);
    const respDescriptor = {
      headerParams: [],
      items: [{ statusCode: 204 }, { statusCode: 404, clazz: ApiError }, { statusCode: 409, clazz: ApiError }]
    };
    return client.fetch(this.http, respDescriptor);
  }
}
